let env = {};

//env.baseURL = 'http://127.0.0.1:8888/api/v1/';
//env.normalURL = 'http://127.0.0.1:8888';
env.baseURL = 'https://api.sigap-central.it4d.com.br/api/v1/';
env.normalURL = 'https://api.sigap-central.it4d.com.br/';

export default env
